import React from "react";
import { Button, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import AttachmentMerge from "../../types/AttachmentMerge.ts";

type AttachmentMergesTableProps = {
  attachmentMerges: Array<AttachmentMerge>;
  hasLink?: boolean;
};
export default function AttachmentMergesTable({ attachmentMerges, hasLink = false }: AttachmentMergesTableProps) {
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Datum</TableCell>
          <TableCell>Betreff</TableCell>
          <TableCell>Absender</TableCell>
          <TableCell>Empfänger</TableCell>
          <TableCell />
        </TableRow>
      </TableHead>
      <TableBody>
        {attachmentMerges.length === 0 && (
          <TableRow>
            <TableCell colSpan={5} sx={{ padding: "1.5rem 0", textAlign: "center" }}>
              Keine Elemente vorhanden
            </TableCell>
          </TableRow>
        )}
        {attachmentMerges.map((attachmentMerge) => (
          <TableRow key={attachmentMerge.id}>
            <TableCell>{dayjs(attachmentMerge.created).format("DD.MM.YYYY, HH:mm")} Uhr</TableCell>
            <TableCell>{attachmentMerge.subject}</TableCell>
            <TableCell>{attachmentMerge.sender}</TableCell>
            <TableCell>{attachmentMerge.recipient}</TableCell>
            <TableCell>
              {hasLink && (
                <Button component={Link} to={"/services/tools/anlagen/" + attachmentMerge.id}>
                  Anhänge verarbeiten
                </Button>
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
